const trainerFunctionalities = [
  "O mnie",
  "Moje wykształcenie",
  "Moje ogłoszenia",
  "Galeria zdjęć",
  "Opinie",
  "Zmień hasło",
  "Moja subskrypcja",
];

const clientFunctionalities = [
  "O mnie",
  "Moje ogłoszenia",
  "Zmień hasło",
  "Wystawione opinie",
];

export { trainerFunctionalities, clientFunctionalities };
